import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

import { ShareManifestContextableTypes, ShareManifestServer } from '@api/v4/share_manifests/ShareManifestTypes';

import { InsightsEvents } from '../insights-events';
import { Metadata } from '../metadata';

import classes from './styles/sidebar.module.scss';

interface SidebarProps {
  assetsHidden: number;
  assetsShown: number;
  manifest: ShareManifestServer;
  requireShareIdentification: boolean;
  resourceName: string;
  resourcePath: string;
  resourceType: ShareManifestContextableTypes;
}

export const Sidebar: FunctionComponent<SidebarProps> = (props) => {
  const {
    assetsHidden,
    assetsShown,
    manifest,
    requireShareIdentification,
    resourceName,
    resourcePath,
    resourceType
  } = props;

  const isPreview = new URLSearchParams(window.location.search).get('preview') === "true";

  if (isPreview) return null;

  return (
    <div className={classNames(classes.sidebar, 'no-print')}>
      <Metadata
        assetsHidden={assetsHidden}
        assetsShown={assetsShown}
        manifest={manifest}
        requireShareIdentification={requireShareIdentification}
        resourceName={resourceName}
        resourcePath={resourcePath}
        resourceType={resourceType}
      />
      <InsightsEvents
        manifest={manifest}
      />
    </div>
  );
};
